import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import API from './../api';
export const fetchConfig = createAsyncThunk(
  'config/fetchConfig',
  async ({ isAdmin } = {}, { rejectWithValue }) => {
    try {
      API.handleError = false;

      const endpoint = isAdmin ? '/admin/config' : '/config';

      const response = await API.get(endpoint);
      const data = JSON.parse(atob(response.data));

      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    } finally {
      API.handleError = true;
    }
  }
);
const configSlice = createSlice({
  name: 'config',
  initialState: {
    status: 'idle',
    error: null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchConfig.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchConfig.fulfilled, (state, action) => {
        const cfg = action.payload;
        // validation minimale
        if (!cfg || !cfg.tenant) {
          state.status = 'failed';
          state.error = 'Invalid config payload';
          return;
        }
        // fusion de la config dans le state (comportement d'avant)
        Object.assign(state, cfg);
        state.status = 'succeeded';
        // Injection du thème
        const theme = cfg?.tenant?.front?.theme;
        if (theme) {
          const root = document.documentElement;
          if (theme.brand_primary)
            root.style.setProperty('--brand-primary', theme.brand_primary);
          if (theme.brand_primary_rgb)
            root.style.setProperty('--brand-primary-rgb', theme.brand_primary_rgb);
          if (theme.brand_dark)
            root.style.setProperty('--brand-dark', theme.brand_dark);
          if (theme.brand_dark_rgb)
            root.style.setProperty('--brand-dark-rgb', theme.brand_dark_rgb);
        }
      })
      .addCase(fetchConfig.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
  },
});
export default configSlice.reducer;